import { Navigate, Outlet } from 'react-router-dom';
import { useContext } from 'react';
import { UserContext } from '../context/UserContext';
import ROUTE_NAME from './url-constants';

const PublicRoutes = () => {
  const contextValues = useContext(UserContext);

  if (!contextValues?.user) {
    return <Outlet />;
  }

  // User is logged in, redirect to dashboard
  return <Navigate to={ROUTE_NAME.DASHBOARD} replace />;
};

export default PublicRoutes;
